import { useEffect, useState } from 'react';
import { Trophy } from 'lucide-react';
import { top10Api } from './top10Api';

export const LocalPlayerTrophy = ({ userId, testId }) => {
  const [earned, setEarned] = useState(false);
  useEffect(() => {
    if (!userId) return undefined;
    let active = true; let version = 0;
    const refresh = () => { const current = ++version; return top10Api.badge(userId).then(value => { if (active && current === version) setEarned(value.local_player === true); }).catch(() => {}); };
    setEarned(false); refresh(); window.addEventListener('focus', refresh); window.addEventListener('top10-updated', refresh);
    return () => { active = false; window.removeEventListener('focus', refresh); window.removeEventListener('top10-updated', refresh); };
  }, [userId]);
  return earned ? <span className="inline-flex shrink-0 ml-2 text-yellow-500" title="Local Player · Top10 completed" aria-label="Local Player trophy" data-testid={testId}><Trophy size={16} aria-hidden="true" /></span> : null;
};